const modes = {
  isRelease: 1,
  isStaging: 2,
  isDebug: 3,
};

const mode = modes.isRelease;

const config = {};

if (mode === modes.isRelease) {
  config.sellerHostname = "https://sellerapi.ajjas.com";
  config.crmHostname = "https://crmapi.ajjas.com";
  config.crmWebsite = "https://crm.ajjas.com";
  config.communityWebsite = "https://community.ajjas.com";
  config.glHostname = "https://api.ajjas.com";
  config.socketHostname = "wss://sellerapi.ajjas.com";
  config.glSocketHostname = "wss://api.ajjas.com";
  config.redirectUrl = "https://www.ajjas.com/";
  config.googleMapsApiKey = "AIzaSyDdSQSnCNpvfsbG49EXYy0zvQauVqp69mw";
} else if (mode === modes.isStaging) {
  config.sellerHostname = "https://foosellerapi.ajjas.com";
  config.crmHostname = "https://foocrmapi.ajjas.com";
  config.crmWebsite = "https://foocrm.ajjas.com";
  config.communityWebsite = "https://foocommunity.ajjas.com";
  config.glHostname = "https://fooapi.ajjas.com";
  config.socketHostname = "wss://foosellerapi.ajjas.com";
  config.glSocketHostname = "wss://fooapi.ajjas.com";
  config.redirectUrl = "https://foo.ajjas.com/";
  config.googleMapsApiKey = "AIzaSyA8DCzXebyD6dbPgauOIPcdMDgqhcaOtBg";
} else {
  config.sellerHostname = "http://localhost:8888";
  config.crmHostname = "http://localhost:9091";
  config.crmWebsite = "http://localhost:3001";
  config.communityWebsite = "http://localhost:9000";
  config.glHostname = "http://localhost:9092";
  config.socketHostname = "wss://localhost:8888";
  config.glSocketHostname = "ws://localhost:9099";
  config.redirectUrl = "http://localhost:9000/";
  config.googleMapsApiKey = "AIzaSyA8DCzXebyD6dbPgauOIPcdMDgqhcaOtBg";
}

export default config;
